/* eslint-disable @typescript-eslint/naming-convention */
import { Type } from '@sinclair/typebox';
import { okResponse } from '../../../routes/defaultResponses';

export const compositionPaths = {
    '/api/objects/composition/bulkCreate': {
        post: {
            operationId: 'compositionControllers.bulkCreateElements',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            clientCompanyId: Type.String({ format: 'uuid' }),
                            ownerCompanyId: Type.String({ format: 'uuid' }),
                            elements: Type.Array(Type.Object({ elementName: Type.String(), elementCode: Type.String(), objectCode: Type.String() })),
                            units: Type.Array(
                                Type.Object({
                                    elementName: Type.String(),
                                    elementCode: Type.String(),
                                    objectCode: Type.String(),
                                    unitName: Type.String(),
                                    unitCode: Type.String(),
                                }),
                            ),
                        }),
                    },
                },
            },
            responses: {
                ...okResponse,
            },
        },
    },
    '/api/objects/composition/bulkDelete': {
        post: {
            operationId: 'compositionControllers.bulkDelete',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            objectIds: Type.Array(Type.String({ format: 'uuid' })),
                        }),
                    },
                },
            },
            responses: {
                ...okResponse,
            },
        },
    },
} as const;
